import React from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import HelpOutlineOutlined from '@mui/icons-material/HelpOutlineOutlined';
import { ProductQualityEnum } from '../Price';
import { colorPalette } from '../../../colorPalette';
export const QualityContent = ({ quality, productType, onRefurbishActionClick }) => {
    return (React.createElement(Stack, { direction: "row", alignItems: "center" },
        React.createElement(Typography, null, "\u2022"),
        React.createElement(Stack, { direction: "row", alignItems: "center" },
            React.createElement(Typography, { padding: "0 4px", fontWeight: 600, sx: {
                    color: colorPalette.gray900,
                } }, ProductQualityEnum[quality]),
            productType === 'RECONDITION' && (React.createElement(Stack, { component: "div", sx: {
                    cursor: 'pointer',
                }, alignItems: "center", justifyContent: "center", onClick: onRefurbishActionClick },
                React.createElement(HelpOutlineOutlined, { sx: {
                        color: colorPalette.gray700,
                    }, fontSize: "small" }))))));
};
